var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29317",
    "data-name": "Group 29317",
    transform: "translate(-437.942 -106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29301",
    "data-name": "Group 29301",
    transform: "translate(-874.058 11164.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1312 -11058.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29298",
    "data-name": "Group 29298",
    transform: "translate(722.892 -11264.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49751",
    "data-name": "Path 49751",
    d: "M18.715,18.249l-5.89-.856-2.634-5.337a.63.63,0,0,0-1.129,0L6.429,17.394l-5.89.856A.63.63,0,0,0,.19,19.323l4.262,4.154L3.446,29.343a.629.629,0,0,0,.913.664l5.268-2.769c5.735,3.015,5.341,2.842,5.561,2.842a.63.63,0,0,0,.62-.736L14.8,23.477l4.262-4.154a.63.63,0,0,0-.349-1.074Z",
    transform: "translate(606 202.294)",
    fill: "#f7ac16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49752",
    "data-name": "Path 49752",
    d: "M9.627,11.689a.63.63,0,0,0-.564.351L6.429,17.377l-5.89.856A.63.63,0,0,0,.19,19.306l4.262,4.154L3.446,29.327a.629.629,0,0,0,.913.664l5.268-2.769h0Z",
    transform: "translate(606 202.311)",
    fill: "#f2d422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49753",
    "data-name": "Path 49753",
    d: "M.539,163.793a.63.63,0,0,0-.349,1.074l4.262,4.154-1.006,5.866a.629.629,0,0,0,.913.664l5.268-2.769c5.735,3.015,5.341,2.842,5.561,2.842a.629.629,0,0,0,.37-.12L6.429,162.937Z",
    transform: "translate(606 56.751)",
    fill: "#f7ac16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49755",
    "data-name": "Path 49755",
    d: "M.25,197.731l4.262,4.154-1.006,5.866a.629.629,0,0,0,.913.664l5.268-2.769c5.735,3.015,5.341,2.842,5.561,2.842a.63.63,0,0,0,.62-.736l-1.006-5.866L.09,197.086A.63.63,0,0,0,.25,197.731Z",
    transform: "translate(605.941 23.886)",
    fill: "#f2d422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49757",
    "data-name": "Path 49757",
    d: "M91.4,207.753a.629.629,0,0,0,.913.664l5.268-2.769c5.735,3.015,5.341,2.842,5.561,2.842a.63.63,0,0,0,.62-.736l-1.006-5.866,4.262-4.154a.63.63,0,0,0,.159-.645l-14.771,4.8Z",
    transform: "translate(518.045 23.885)",
    fill: "#f7ac16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49759",
    "data-name": "Path 49759",
    d: "M98.955,175.551l5.268-2.769c5.735,3.015,5.341,2.842,5.561,2.842a.63.63,0,0,0,.62-.736l-1.006-5.866,4.262-4.154a.63.63,0,0,0-.349-1.074l-5.89-.856L98.292,175.5A.629.629,0,0,0,98.955,175.551Z",
    transform: "translate(511.404 56.75)",
    fill: "#f2d422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49760",
    "data-name": "Path 49760",
    d: "M113.819,197.086l-9.6,3.118-5.931,8.163a.629.629,0,0,0,.663.048l5.268-2.769c5.735,3.015,5.341,2.842,5.561,2.842a.63.63,0,0,0,.62-.736l-1.006-5.866,4.262-4.154A.63.63,0,0,0,113.819,197.086Z",
    transform: "translate(511.404 23.886)",
    fill: "#f7ac16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49761",
    "data-name": "Path 49761",
    d: "M109.4,281.68,104.223,280l-5.931,8.163a.629.629,0,0,0,.663.048l5.268-2.769c5.735,3.015,5.341,2.842,5.561,2.842a.63.63,0,0,0,.62-.736L109.4,281.68Z",
    transform: "translate(511.404 -55.908)",
    fill: "#f2d422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49762",
    "data-name": "Path 49762",
    d: "M98.292,288.161a.629.629,0,0,0,.663.048l5.268-2.769c5.735,3.015,5.341,2.842,5.561,2.842a.629.629,0,0,0,.37-.12L104.223,280Z",
    transform: "translate(511.404 -55.908)",
    fill: "#f7ac16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49763",
    "data-name": "Path 49763",
    d: "M104.223,280h0l-5.931,8.163a.629.629,0,0,0,.663.048l5.268-2.769h0Z",
    transform: "translate(511.404 -55.908)",
    fill: "#f2d422"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHighlighted);
export default __webpack_public_path__ + "static/media/starHighlighted.25e00c9dca0a263e5ae4302890dd6a86.svg";
export { ForwardRef as ReactComponent };